import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { refresh } from '../../services/auth.service';
import Spinner from '../../components/layout/Spinner';
import FadeIn from '../../utils/fadein';
import { FaEllipsisV, FaTimes } from 'react-icons/fa';
import { getExclusiveRequests, approveExclusiveRequest } from '../../utils/api/admin';

function ExclusiveRequests() {
  const [loaded, setLoaded] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [pageBreakdown, setPageBreakdown] = useState([]);
  const [data, setData] = useState([]);
  const [showSaveBanner, setShowSaveBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const imageUrl = process.env.REACT_APP_IMAGE_URL;
  const baseImageUrl = process.env.REACT_APP_BASE_IMAGE_URL;
  const screenshotUrl = process.env.REACT_APP_BASE_IMAGE_URL + 'companyscreenshots/';

  useEffect(() => {
    async function loadData(){
      let res = await getExclusiveRequests();
      if (res.success){
        setData(res.data);
        setLoaded(true);
      } else {
        console.log('Error loading data:', res.message);
      }
    }

    loadData();
  }, []);

  function loadSaveBanner(){
    setShowSaveBanner(true);
    const timer = setTimeout(() => {
      setShowSaveBanner(false);
    }, 3000);
    return () => clearTimeout(timer);
  }

  const handleApprove = async (id) => {
  
    setSubmitting(true);

    let res = await approveExclusiveRequest(id);

    if (res.success){
      // TODO: Implement approve API call here
      setSubmitting(false);
      loadSaveBanner();

      setData(data.map(item => item.registered_user_id === id ? { ...item, status: 'Approved' } : item));
    }
  };

  const getBadgeClass = (status) => {
    switch (status.toLowerCase()) {
      case 'pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'approved':
        return 'bg-green-100 text-green-800';
      case 'rejected':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <>
      <Helmet>
        <title>LeadrPro - Discover new software</title>
      </Helmet>

      <h1>Company Saves {`(${data.length})`}</h1>

      {loaded===false && (
        <Spinner />
      )}

      {loaded && (
         <div>
          <table className='admindashboard__table table'>
            <tr>
              <th>Name</th>
              <th>Bio</th>
              <th>Company Name</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>

            {data.map((item, index) => (
              <tr key={index}>
                <td>
                  <div>{new Date(item.date_created).toLocaleDateString()}</div>
                  {item.registered_user_id}: {item.first_name} {item.last_name}
                </td>

                <td>
                  <div>
                    <strong>Registered On</strong>
                    <div>
                      {new Date(item.date_registered).toLocaleDateString()} {new Date(item.date_registered).toLocaleTimeString()}
                    </div>
                  </div>
                  <div>
                    <strong>Role</strong>
                    <p>{item.purchasing_role}</p>
                  </div>

                  <div>
                    <strong>Purchase Timeline</strong>
                    <p>{item.purchasing_timeline}</p>
                  </div>

                  <div>
                    <strong>Technology Stack</strong>
                    <p>{item.technology_stack}</p>
                  </div>

                  <div>
                    <strong>Business Challenges</strong>
                    <p>{item.business_challenges}</p>
                  </div>

                  <div>
                    <strong>Tech Goals</strong>
                    <p>{item.technology_goals}</p>
                  </div>
                </td>

                <td>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {item.logo && (
                       <img className='w-10 h-10' src={imageUrl + 'tr:di-@@companylogos@@default-buyer.png/' + item.logo} />
                    )}
                    {item.company_name}
                  </div>

                  <div>
                    <strong>Website</strong>
                    <p>{item.website}</p>
                  </div>

                  <div>
                    <strong>Job Title</strong>
                    <p>{item.job_title}</p>
                  </div>
                </td>

                <td>
                  <span className={`px-2 py-1 text-sm font-medium rounded-full ${getBadgeClass(item.status)}`}>
                    {item.status}
                  </span>
                </td>

                <td>
                  {item.status === 'Pending' && (
                    <button 
                      className="btn btn-primary btn-sm"
                      onClick={() => handleApprove(item.registered_user_id)}
                      disabled={submitting}
                    >
                      {submitting ? 'Processing...' : 'Approve'}
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </table>
       </div>
      )}

    {showModal && (
        <>
          <div className='overlay'></div>
          <div className='modal'>
            <div className='modal__close' onClick={() => setShowModal(false)}>
              <FaTimes />
            </div>

            <h2 className='modal__h2'>Admin Note</h2>

            <div className='mt-10'>
            
            </div>
          </div>
        </>
      )}

      {showSaveBanner && (
        <FadeIn delay={150} duration={300}>
          <div className='profileinfo__saved-banner'>
            Profile updated successfully!
          </div>
        </FadeIn>
      )}
    </>
  );
}

export default ExclusiveRequests;